export default () => `
  Seismic Conditions: The changing or dynamic lateral load due to earthquake activity. For arrays located in seismic areas, the design of the support structure should resist the additional horizontal load. 
`;
